import type { InventoryDrone } from '@/lib/api/types';

const empty = (v: string | null | undefined): boolean => {
  const s = (v ?? '').trim().toLowerCase();
  return s === '' || s === '—' || s === '--' || s === 'unknown';
};

/**
 * "Brand Model" for the fleet card (ENG-271). The live telemetry carries no
 * model (the pipeline sends an empty string, which surfaces as "Unknown"), so
 * fall back to the aircraft's Custodian inventory record. Null when neither
 * knows, so the card omits the segment instead of printing a placeholder.
 */
export function makeModelLabel(
  telemetryModel: string | null | undefined,
  inventory: Pick<InventoryDrone, 'brand' | 'model'> | null | undefined,
): string | null {
  if (!empty(telemetryModel)) return (telemetryModel as string).trim();
  if (!inventory) return null;
  const brand = empty(inventory.brand) ? '' : inventory.brand.trim();
  const model = empty(inventory.model) ? '' : inventory.model.trim();
  if (!brand && !model) return null;
  if (brand && model && model.toLowerCase().startsWith(brand.toLowerCase())) return model;
  return [brand, model].filter(Boolean).join(' ');
}
